export default __webpack_public_path__ + "static/media/home.3a7cb0e8.svg";